<script lang="ts">
	import EmailLoginForm from './_components/email-login-form.svelte';
	import { Separator } from '$lib/components/ui/separator';
	import { Button } from '$lib/components/ui/button';
	import * as Card from '$lib/components/ui/card';
	import Google from '$lib/assets/svg/google.svg';
	import { page } from '$app/stores';
	import { cn } from '$lib/utils';

	let { data } = $props();
</script>

<div
	class={cn(
		$page.state.modal
			? 'max-w-md p-1'
			: "flex min-h-svh flex-1 items-center justify-center bg-muted/40 bg-[url('/src/lib/assets/svg/test.svg')] bg-cover bg-no-repeat dark:bg-[url('/src/lib/assets/svg/dark_test.svg')]"
	)}
>
	<Card.Root class={cn($page.state.modal ? 'border-none shadow-none' : 'my-4')}>
		<Card.Header class={cn($page.state.modal ? 'px-0 pt-0 text-center' : 'text-center')}>
			<Card.Title level={1}>Einloggen</Card.Title>
			<Card.Description>Willkommen zurück! Bitte melde dich an um fortzufahren</Card.Description>
		</Card.Header>
		<Card.Content
			class={cn($page.state.modal ? 'flex flex-col gap-6 px-0' : 'flex flex-col gap-6')}
		>
			<EmailLoginForm
				data={data.form}
				redirectTo={$page.state.modal ? `${$page.url.pathname + $page.url.search}` : undefined}
			/>
			<Separator
				class="my-4 flex items-center justify-center before:bg-background before:px-4 before:text-sm before:text-muted-foreground before:content-['oder']"
			/>
			<Button variant="outline" class="flex gap-2" href="/login/google">
				<img src={Google} alt="Google Logo" class="size-5" />
				Google
			</Button>
		</Card.Content>
		<Card.Footer
			class={cn($page.state.modal ? 'justify-center p-0 text-sm' : 'justify-center text-sm')}
		>
			<p>
				Du hast keinen Account? <a href="/registrieren" class="text-primary underline"
					>Registrieren</a
				>
			</p>
		</Card.Footer>
	</Card.Root>
</div>
